import { type OperationResponse, type Parameters } from "../../common.ts";
import { omitPathParameters, replacePathParameters } from "../../utils.ts";
import type { AxiosInstance, AxiosRequestConfig } from "axios";

import type * as Paths from "./paths";

interface OperationMethods {
  "transferOwnership"(
    parameters?: Parameters<Paths.TransferOwnership.PathParameters> | null,
    data?: Paths.TransferOwnership.RequestBody,
    config?: AxiosRequestConfig,
  ): OperationResponse<Paths.TransferOwnership.Responses.$200>;
}

export const getUserOperations = (client: AxiosInstance) => {
  const transferOwnership: OperationMethods["transferOwnership"] = (
    parameters,
    data,
    config,
  ) => {
    const url = "/{id}/transfer-ownership";
    return client.post(replacePathParameters(url, parameters), data, {
      params: omitPathParameters(parameters, url),
      ...config,
    });
  };

  return {
    transferOwnership,
  };
};
